





































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import { userUtils } from "../../_utils/userUtils";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import * as temp from "../../_store/temp.module";
import { router } from "../../_router";
import CreateDialog from "../../components/Dialogs/CreateDialog.vue";

@Component({
  components: {
    CardTitle,
    DetailsDataTable,
    CreateDialog
  }
})
export default class ColloquiAzienda extends Vue {
  @Prop() idIscrizioneAttivita!: number;
  @Prop() idIstituto!: number;
  @Prop() idAnnoScolastico!: number;
  @Prop() statoPeriodoIscrizione!: boolean;
  @Prop() statoPubblicazione!: boolean;
  @Prop() dataFineAttivita!: string;

  private titleParams: object;
  private dataTableParams: any;
  private createDialogParams: object;
  private schedules: any;

  private giorniColloqui: any;

  private enableChanges: boolean;
  private listaPreferenze: any;
  private showCreate: boolean;
  private published: boolean;

  constructor() {
    super();
    this.enableChanges = true;
    this.published = false;
    this.listaPreferenze = [];
    this.giorniColloqui = [];
    this.showCreate = true;
    this.titleParams = {
      title: "Colloqui",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Allievo",
          value: "username",
          sortable: false
        },
        {
          text: "Classe",
          value: "classe",
          sortable: false
        },
        {
          text: "Email Allievo/a",
          value: "emailUtente"
        },
        // {
        //   text: "Dettagli Allievo",
        //   value: "action",
        //   sortable: false
        // },
        {
          text: "Turno Colloquio",
          value: "turno"
        },
        {
          text: "Giorno Colloquio",
          value: "giorno"
        },
        {
          text: "Condividi Stanza",
          value: "condividiStanza",
          sortable: false
        },
        {
          text: "Report Colloquio",
          value: "questionarioColloquio",
          sortable: false
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI ALLIEVO",
        type: "userTab"
      },
      detailsColloquioDialogParams: {
        title: "QUESTIONARIO COLLOQUIO",
        type: "infoColloquio"
      },
      colloquioDialogParams: {
        title: "QUESTIONARIO COLLOQUIO",
        type: "colloquio"
      },
      type: "colloqui"
    };
    this.createDialogParams = {
      visible: true,
      idIstituto: this.idIstituto,
      isIscrizioneAttivita: this.idIscrizioneAttivita,
      type: "nuovaPreferenzaColloquio"
    };
    this.schedules = [];
  }

  loadColloqui() {
    // var schedules = [];
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var record: any;
    var schedule: {
      idArticolazione: number;
      linkStanza: string;
      tableRecords: any;
    };
    var articolazioniList: any = [];
    var articolazione: string;
    var enterpriseInfo: EnterpriseInfo = user.readEnterpriseInfo(
      this["$store"]
    );
    var payload = {
      idAnnoScolastico: idAnnoScolastico,
      idAzienda: enterpriseInfo.idAzienda
    };
    var link: string | null = "";
    data
      .dispatchColloquiAzienda(this["$store"], payload)
      .then(result => {
        for (let i = 0; i < result.length; i++) {
          articolazione = result[i].articolazione;
          if (!articolazioniList.includes(articolazione)) {
            articolazioniList.push(articolazione);
          }
        }
        schedule = {
          idArticolazione: 0,
          linkStanza: "",
          tableRecords: []
        };
        articolazioniList.forEach((element: any) => {
          schedule.idArticolazione = element;
          schedule.tableRecords = JSON.parse(
            JSON.stringify(this.dataTableParams)
          );
          for (let j = 0; j < result.length; j++) {
            if (result[j].articolazione === element) {
              link = result[j].linkStanza;
              schedule.tableRecords.records.push(result[j]);
            }
          }
          this.schedules.push({
            idArticolazione: schedule.idArticolazione,
            linkStanza: link,
            tableRecords: schedule.tableRecords
          });
        });
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  loadPreferenzaColloquio() {
    data
      .dispatchPreferenzeColloquio(this["$store"], this.idIscrizioneAttivita)
      .then(result => {
        this.listaPreferenze = result;
        this.enableChanges = this.statoPeriodoIscrizione;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  loadGiorniColloqui() {
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var payload = {
      idAzienda: enterpriseInfo.idAzienda,
      idAnnoScolastico: idAnnoScolastico,
      idIstituto: this.idIstituto
    };
    data
      .dispatchGiorniColloquiAzienda(this["$store"], payload)
      .then(result => {
        this.giorniColloqui = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  deletePreferenza(idInformazioneColloquio: number) {
    if (confirm("Cancellare Preferenza Settore?")) {
      user
        .dispatchDeletePreferenzaColloquio(
          this["$store"],
          idInformazioneColloquio
        )
        .then(() => {
          bus.$emit(
            "successfullOperation",
            "Preferenza Settore cancellata con successo"
          );
          this.loadPreferenzaColloquio();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    }
  }

  created() {
    if (
      this.idIscrizioneAttivita !== undefined &&
      this.idIscrizioneAttivita !== null
    ) {
      var token = localStorage.getItem("userToken");
      var parsedToken: any;
      if (token !== null) {
        parsedToken = userUtils.parseToken(token);
      }
      var payload = {
        idUtente: parsedToken.IdUtente,
        tipoSoggetto: parsedToken.IdTipoSoggetto,
        username: parsedToken.Username
      };
      user
        .dispatchSetUserInfo(this["$store"], payload)
        .then(() => {
          user
            .dispatchSetEnterpriseInfo(this["$store"])
            .then(() => {
              this.published = this.statoPubblicazione;
              this.loadPreferenzaColloquio();
              this.loadGiorniColloqui();
              this.loadColloqui();
              bus.$emit("loadMenu");
            })
            .catch(() => {
              bus.$emit("stopLoading");
              auth.dispatchLogout(this["$store"]);
              user.dispatchClearState(this["$store"]);
              this["$router"].push("/sessionExpired");
            });
        })
        .catch(() => {
          bus.$emit("stopLoading");
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/sessionExpired");
        });
    } else {
      router.push({
        name: "iscrizioniColloqui",
        params: {}
      });
    }

    bus.$on("loadColloqui", () => {
      this.schedules = [];
      this.loadColloqui();
    });

    bus.$on("loadPreferenzeWorkshop", async () => {
      this.showCreate = false;
      await this.$nextTick();
      this.showCreate = true;
      this.loadPreferenzaColloquio();
    });
  }
}
